import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ContentTile from 'components/atoms/layout/ContentTile';

import noChartIcon from 'assets/icons8-combo_chart.png';
import brokenIcon from 'assets/icons8-broken_link.png';
import lockIcon from 'assets/icons8-lock_2.png';
import loadingGif from 'assets/loading.gif';

const ErrorContentTile = styled(ContentTile)`
    padding: 48px 10px 60px;
    text-align: center;
    img {
         display: block;
         margin: auto;
         margin-bottom: 24px;
     }
     h3 {
        color: #7F7F7F;
        margin-top: 0;
        font-weight: 300;
        line-height: 32px;
    }
`;

const ErrorTile = props => (
    <ErrorContentTile className={props.className}>
        <div>
            {props.iconSrc &&
                <img src={props.iconSrc} alt={props.iconAlt} />
            }
            <h3>{props.header}</h3>
            {props.children}
        </div>
    </ErrorContentTile>
);

ErrorTile.defaultProps = {
    iconAlt: ''
};

ErrorTile.propTypes = {
    header: PropTypes.string,
    iconAlt: PropTypes.string,
    iconSrc: PropTypes.string
};

export default ErrorTile;

export const LoadingTile = styled(ErrorTile).attrs(() => ({
    iconSrc: loadingGif,
    header: 'LOADING ...'
}))``;

export const NoChannelDataTile = styled(ErrorTile).attrs(props => ({
    iconSrc: noChartIcon,
    header: `No ${props.channel || ''} data for that date range`,
    children: (props.children ? props.children : (<p>
        To add {props.channel} to your plan, please contact our support team
    </p>))
}))``;

export const PageNotFoundTile = styled(ErrorTile).attrs(props => ({
    iconSrc: brokenIcon,
    header: 'Whoops… page not found',
    children: (props.children ? props.children : (<p>
        If you continue to have issues, please contact our support team
    </p>))
}))``;

export const NoAccessTile = styled(ErrorTile).attrs(props => ({
    iconSrc: lockIcon,
    header: 'You don’t have access to that page',
    children: (props.children ? props.children : (<p>
        If you continue to have issues, please contact our support team
    </p>))
}))``;

export const NoDataTile = styled(ErrorTile).attrs(props => ({
    iconSrc: noChartIcon,
    header: props.title,
    children: (props.children ? props.children : (<p>
        There is no data to show for this date range
    </p>))
}))`
    height: ${props => props.height || '100%'};
    display: flex;
    justify-content: center;
    align-items: center;
`;



// WEBPACK FOOTER //
// ./src/components/molecules/ErrorTile.js